'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSketch = require('react-sketch');

var _colors = require('../../libs/colors');

var colors = _interopRequireWildcard(_colors);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Wrapper = require('./components/Wrapper');

var _Wrapper2 = _interopRequireDefault(_Wrapper);

var _Container = require('./components/Container');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content');

var _Content2 = _interopRequireDefault(_Content);

var _Img = require('./components/Img');

var _Img2 = _interopRequireDefault(_Img);

var _ActionsContainer = require('./components/ActionsContainer');

var _ActionsContainer2 = _interopRequireDefault(_ActionsContainer);

var _Action = require('./components/Action');

var _Action2 = _interopRequireDefault(_Action);

var _HidableContainer = require('./components/HidableContainer');

var _HidableContainer2 = _interopRequireDefault(_HidableContainer);

var _ComputedImage = require('./components/ComputedImage');

var _ComputedImage2 = _interopRequireDefault(_ComputedImage);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Colors
// Components


var ImageSketch = function (_Component) {
  _inherits(ImageSketch, _Component);

  function ImageSketch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageSketch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageSketch.__proto__ || Object.getPrototypeOf(ImageSketch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      render: false,
      hover: false,
      src: null
    }, _this.sketch = null, _this.mount = function () {
      if (!_this.mounted) return;

      _this.setState({
        render: true
      });
    }, _this.onHover = function () {
      return _this.setState({
        hover: true
      });
    }, _this.onBlur = function () {
      return _this.setState({
        hover: false
      });
    }, _this.onChange = function () {
      if (!_this.sketch || !_this.sketch._canvas || !_this.mounted) return;

      var src = _this.sketch._canvas.toDataURL('image/png');

      _this.setState({
        src: src
      });
    }, _this.sketchRef = function (dom) {
      if (!dom || !dom._canvas) return;
      _this.sketch = dom;

      _this.onChange();
    }, _this.undo = function () {
      if (!_this.sketch) return;

      _this.sketch.undo();
    }, _this.clear = function () {
      if (!_this.sketch) return;

      _this.sketch.clear();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageSketch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.mounted = true;
      var img = new Image();

      img.onload = function () {
        return setTimeout(_this2.mount, 10);
      };

      img.src = this.props.image;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          render = _state.render,
          hover = _state.hover,
          src = _state.src;
      var _props = this.props,
          image = _props.image,
          color = _props.color,
          actions = _props.actions,
          converting = _props.converting;
      return _react2.default.createElement(_Wrapper2.default, {
        onMouseEnter: this.onHover,
        onMouseLeave: this.onBlur
      }, _react2.default.createElement(_HidableContainer2.default, {
        visible: !converting
      }, _react2.default.createElement(_Container2.default, null, _react2.default.createElement(_Img2.default, {
        src: image
      }), _react2.default.createElement(_Content2.default, null, render && _react2.default.createElement(_reactSketch.SketchField, {
        width: '100%',
        height: '100%',
        tool: _reactSketch.Tools.Pencil,
        lineColor: colors[color],
        lineWidth: 2,
        ref: this.sketchRef,
        onChange: this.onChange
      })))), _react2.default.createElement(_HidableContainer2.default, {
        visible: converting && !!src
      }, _react2.default.createElement(_Img2.default, {
        src: image
      }), _react2.default.createElement(_Content2.default, null, _react2.default.createElement(_ComputedImage2.default, {
        src: src
      }))), render && actions && !converting && _react2.default.createElement(_ActionsContainer2.default, {
        visible: hover
      }, _react2.default.createElement(_Action2.default, {
        onClick: this.clear
      }, _react2.default.createElement(_Icon2.default, {
        icon: 'close'
      })), _react2.default.createElement(_Action2.default, {
        onClick: this.undo
      }, _react2.default.createElement(_Icon2.default, {
        icon: 'enter'
      }))));
    }
  }]);

  return ImageSketch;
}(_react.Component);

ImageSketch.propTypes = {
  image: _propTypes2.default.string.isRequired,
  color: _propTypes2.default.oneOf(Object.keys(colors)),
  actions: _propTypes2.default.bool,
  converting: _propTypes2.default.bool
};
ImageSketch.defaultProps = {
  color: 'black',
  actions: false,
  converting: false
};
exports.default = ImageSketch;